const stepmods = (() => {
    let mods:number[] = [];
    for (let i = -60; i <= 60; i++) mods.push(i);
    return mods;
})();

export default stepmods;